import {reverse} from 'lodash'
import {Action, AnyAction, Reducer} from 'redux'

export const composeReducers =
  <TState, TAction extends Action<any> = AnyAction>(...reducers: Reducer<TState, TAction>[]) =>
  (state: TState | undefined, action: TAction) =>
    reverse(reducers).reduce((state, reducer) => reducer(state, action), state) as TState

const UPDATE_ENTITY = 'UPDATE_ENTITY'

export const updateEntityReducer = (state: any, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_ENTITY:
      return {
        ...state,
        entities: {
          ...(state?.entities || {}),
          [action.entity]: {
            ...state?.entities[action.entity],
            [action.id]: action.updater(state.entities?.[action.entity]?.[action.id]),
          },
        },
      }
  }

  return state
}
